<template>
    <v-row>
        <v-col cols="12" md="4">
            <v-select ref="condicao"
                      id="SelectPoliticamenteExposto"
                      label="Condição (Politicamente exposto):"
                      :placeholder="value.politicamente_exposto ? '' : 'Selecione a condição'"
                      class="required"
                      outlined
                      name="politicamenteExpostoName"
                      :items="opcoes_politicamente_exposto_upper"
                      item-text="nome"
                      item-value="id"
                      :rules="[$rules.required]"
                      v-model="value.politicamente_exposto" />
        </v-col>
        <v-col cols="12" md="4" v-if="value.politicamente_exposto === politicamente_exposto_parente">
            <v-select ref="parentesco"
                      id="SelectParentesco"
                      label="Parentesco:"
                      placeholder="Selecione o parentesco"
                      class="required"
                      outlined
                      :items="parentescos"
                      item-text="nome"
                      item-value="id_parentesco"
                      :rules="[$rules.required]"
                      v-model="value.id_parentesco" />
        </v-col>
        <v-col cols="12" md="4" v-if="value.politicamente_exposto && value.politicamente_exposto !== nao_politicamente_exposto">
            <Autocomplete ref="cargo"
                          id="FieldCargo"
                          label="Cargo:"
                          class="required"
                          :rules="[$rules.required]"
                          url="/politicamente_exposto/cargos/autocomplete"
                          :items.sync="cargos"
                          v-input-filter="[$filters.textnumeric]"
                          v-model="value.id_cargo_politico"
                          item-text="nome"
                          item-value="id_cargo_politico"
                          placeholder="Selecione um cargo" />
        </v-col>
    </v-row>
</template>

<script>
  import { PoliticamenteExposto, PoliticamenteExpostoDesc } from '@/plugins/constants'
  import { notification } from '../../../plugins/helpers'

  export default {
    name: 'PoliticamenteExposto',
    props: { value: Object },
    data: () => ({
      opcoes_politicamente_exposto: [],
      parentescos: [],
      cargos: []
    }),
    computed: {
      nao_politicamente_exposto: () => PoliticamenteExposto.NaoPoliticamenteExposto,
      politicamente_exposto_parente: () => PoliticamenteExposto.ParenteAgentePublico,
      politicamente_exposto_colaborador: () => PoliticamenteExposto.EstreitoColaborador,
      opcoes_politicamente_exposto_upper () {
        return Object.keys(PoliticamenteExpostoDesc).map((id) => ({ id, nome: PoliticamenteExpostoDesc[id].toUpperCase() }))
      }
    },
    watch: {
      'value.id_parentesco' () {
        this.update()
      },
      'value.politicamente_exposto' (politicamente_exposto) {
        if (politicamente_exposto === PoliticamenteExposto.NaoPoliticamenteExposto) {
          this.value.id_parentesco = null
          this.value.id_cargo_politico = null
          this.update()
        }
      },
      'value.id_cargo_politico' (id_cargo_politico) {
        if (id_cargo_politico && this.cargos.length === 0) {
          this.getCargos(id_cargo_politico)
        }
      }
    },
    created () {
      this.getParentescos()
    },
    methods: {
      update () {
        this.$emit('input', this.value)
      },
      getParentescos () {
        this.$http.get('/politicamente_exposto/parentescos')
          .then(res => {
            this.parentescos = res.data
          })
      },
      getCargos (id_cargo_politico) {
        this.$http.get(`/politicamente_exposto/cargos/${id_cargo_politico}`)
          .then(res => {
            this.cargos = res.data
          })
          .catch(() => {
            notification('warning', 'Não foi possível buscar o cargo cadastrado do cliente.')
          })
      },
      reset () {
        if (this.$refs.condicao) {
          this.$refs.condicao.reset()
        }
        if (this.$refs.parentesco) {
          this.$refs.parentesco.reset()
        }
        if (this.$refs.cargo) {
          this.$refs.cargo.reset()
        }
      }
    }
  }
</script>
